module.exports = __webpack_public_path__ + "img/004-bald.c07027fb.svg";